<script lang="ts">
	let customClass = "";
	export { customClass as class };
	export let hoverClass = "group-hover:opacity-100";
</script>

<div
	class="pointer-events-none absolute left-0 right-0 top-full z-10 mt-2 text-xs opacity-0 transition-opacity duration-300 {hoverClass}"
>
	<div class="mx-auto w-fit rounded-md border border-secondary-250 bg-secondary-150 p-2 text-secondary {customClass}">
		<slot />
	</div>
</div>
